import { BaseAIAdapter, AIAdapterResponse } from './AIAdapter';
import { aiConfig } from '../config/ai';

export class AnthropicAdapter extends BaseAIAdapter {
  readonly system = 'anthropic' as const;
  readonly name = 'Claude';
  protected apiKey: string;
  private model: string;

  constructor() {
    super();
    this.apiKey = aiConfig.anthropic.apiKey;
    this.model = aiConfig.anthropic.model;
  }

  async query(prompt: string): Promise<AIAdapterResponse> {
    if (!this.isConfigured()) {
      throw new Error('Anthropic adapter is not configured. Please provide an API key.');
    }

    try {
      const response = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': this.apiKey,
          'anthropic-version': '2023-06-01',
        },
        body: JSON.stringify({
          model: this.model,
          max_tokens: 4096,
          messages: [
            {
              role: 'user',
              content: prompt,
            },
          ],
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error?.message || `HTTP ${response.status}`);
      }

      const data = await response.json();
      const text = data.content[0]?.text || '';

      return {
        rawText: text,
        modelVersion: data.model,
        timestamp: new Date(),
      };
    } catch (error: any) {
      this.handleError(error, 'Anthropic');
    }
  }

  getCacheTTL(): number {
    // Training-only, very stable - aggressive caching (48+ hours)
    return 48 * 60 * 60 * 1000;
  }
}
